<template>
    <numbering-check-settings
        model-name="creditnote"
        document-label="le note di credito"
    />
</template>

<script>
import NumberingCheckSettings from '@/components/common/NumberingCheckSettings'

export default {
    name: 'creditnotes-other',
    components: {
        NumberingCheckSettings
    }
}
</script>
